/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.
*/

(function() {

  document.addEventListener('DOMContentLoaded', function() {

    // Inicializar precio por cápsula
    document.querySelectorAll('[data-variant-selector]').forEach(function(container) {
      const productBlock = container.closest('[data-product-block]');
      if (!productBlock) return;

      container.querySelectorAll('.product-card__qty-chip').forEach(function(c) {
        c.classList.remove('active');
      });

      const chips = container.querySelectorAll('.product-card__qty-chip');
      let bestPricePerUnit = Infinity;

      chips.forEach(function(chip) {
        const priceRaw = parseInt(chip.dataset.priceRaw, 10);
        const units = parseInt(chip.dataset.units, 10);
        if (!priceRaw || !units) return;
        const pricePerUnit = (priceRaw / 100) / units;
        if (pricePerUnit < bestPricePerUnit) bestPricePerUnit = pricePerUnit;
      });

      const priceDisplay = productBlock.querySelector('[data-price-display]');
      if (!priceDisplay || bestPricePerUnit === Infinity) return;

      const formatted = '$' + Math.round(bestPricePerUnit).toLocaleString('es-CL');
      priceDisplay.innerHTML = '<span>Desde ' + formatted + ' x Cápsula</span>';
    });

    // Clic en chip de variante
    document.addEventListener('click', function(e) {
      const chip = e.target.closest('.product-card__qty-chip');
      if (!chip) return;

      e.preventDefault();

      const price = chip.dataset.price;
      const priceRaw = parseInt(chip.dataset.priceRaw, 10);
      const comparePrice = chip.dataset.comparePrice;
      const comparePriceRaw = chip.dataset.comparePriceRaw ? parseInt(chip.dataset.comparePriceRaw, 10) : 0;
      const units = parseInt(chip.dataset.units, 10);
      const variantId = chip.dataset.variantId;
      const soldOut = chip.dataset.soldOut === 'true';
      const container = chip.closest('[data-variant-selector]');
      const productBlock = chip.closest('[data-product-block]');
      if (!productBlock || !container) return;

      container.querySelectorAll('.product-card__qty-chip').forEach(function(c) {
        c.classList.remove('active');
      });
      chip.classList.add('active');

      // Actualizar badge de descuento
      const discount = chip.dataset.discount;
      const savingBadge = productBlock.querySelector('[data-saving-badge]');
      if (savingBadge) {
        if (discount && parseInt(discount) > 0) {
          savingBadge.style.display = '';
          savingBadge.querySelector('span').textContent = discount + '% OFF';
        } else {
          savingBadge.style.display = 'none';
        }
      }

      // Precio por cápsula
      const pricePerUnit = Math.round((priceRaw / 100) / units);
      const formattedPerUnit = '$' + pricePerUnit.toLocaleString('es-CL');

      const priceDisplay = productBlock.querySelector('[data-price-display]');
      if (!priceDisplay) return;

      let html = '<div class="price__variant-display">';

      if (soldOut) {
        html += '<div class="price__variant-main">';
        html += '<s class="price__variant-soldout">' + price + '</s>';
        html += '</div>';
        html += '<div class="price__variant-normal">Agotado · ' + formattedPerUnit + ' x Cápsula</div>';
      } else if (comparePrice && comparePrice !== price && comparePriceRaw > priceRaw) {
        const savings = (comparePriceRaw - priceRaw) / 100;
        const formattedSavings = '$' + savings.toLocaleString('es-CL');
        html += '<div class="price__variant-main">';
        html += '<span class="price__variant-current">' + price + '</span>';
        html += '<s class="price__variant-compare">' + comparePrice + '</s>';
        html += '</div>';
        html += '<div class="price__variant-savings">Ahorras ' + formattedSavings + '</div>';
        html += '<div class="price__variant-normal">' + formattedPerUnit + ' x Cápsula</div>';
      } else {
        html += '<div class="price__variant-main">';
        html += '<span class="price__variant-current">' + price + '</span>';
        html += '</div>';
        html += '<div class="price__variant-normal">' + formattedPerUnit + ' x Cápsula</div>';
      }

      html += '</div>';
      priceDisplay.innerHTML = html;

      // Cambiar imagen según variante
      if (variantId) {
        const variantImage = chip.dataset.variantImage;
        if (variantImage) {
          const mainImg = productBlock.querySelector('figure[data-main-image] img');
          if (mainImg) {
            const src = variantImage.startsWith('http') ? variantImage : 'https:' + variantImage;
            mainImg.src = src;
            mainImg.srcset = '';
          }
        }
      }

      // Guardar variante activa en el botón quick buy
      const quickBuyBtn = productBlock.querySelector('[data-button-quick-view]');
      if (quickBuyBtn) {
        quickBuyBtn.dataset.activeVariant = variantId;
      }
    });

    // Interceptar quick buy con variante seleccionada
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-button-quick-view]');
      if (!btn) return;

      const activeVariant = btn.dataset.activeVariant;
      if (!activeVariant) return;

      e.preventDefault();
      e.stopPropagation();

      btn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(activeVariant), quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status) {
          console.error('Error:', data.description);
          btn.classList.remove('is-loading');
          return;
        }
        btn.classList.remove('is-loading');
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            setTimeout(function() {
              const cartToggle = document.querySelector('[data-cart-drawer-toggle]');
              if (cartToggle) cartToggle.click();
            }, 300);
          });
      })
      .catch(function(err) {
        console.error('Error al agregar:', err);
        btn.classList.remove('is-loading');
      });
    }, true);

    // Precargar imágenes de variantes
    document.querySelectorAll('.product-card__qty-chip[data-variant-image]').forEach(function(chip) {
      const src = chip.dataset.variantImage;
      if (src) {
        const img = new Image();
        img.src = src.startsWith('http') ? src : 'https:' + src;
      }
    });

  });

})();